/** Note object - "When did it happen?" */
export var NoteObjectType;
(function (NoteObjectType) {
    NoteObjectType["BOOKING"] = "booking";
    NoteObjectType["ITINERARY"] = "itinerary";
    NoteObjectType["ORDER"] = "order";
    NoteObjectType["PROCEDURE"] = "procedure";
    NoteObjectType["WAYPOINT"] = "waypoint";
    NoteObjectType["WAYPOINT_ACTION"] = "waypointAction";
})(NoteObjectType || (NoteObjectType = {}));
/** Note subject - "What was involved?" */
export var NoteSubjectType;
(function (NoteSubjectType) {
    NoteSubjectType["CARESEND"] = "careSend";
    NoteSubjectType["PLACE"] = "place";
    NoteSubjectType["SUPPLY"] = "supply";
    NoteSubjectType["TASK"] = "task";
    NoteSubjectType["TEST"] = "test";
    NoteSubjectType["USER"] = "user";
})(NoteSubjectType || (NoteSubjectType = {}));
/** Category assigned to the Note */
export var NoteCategory;
(function (NoteCategory) {
    NoteCategory["ACCESS_ISSUE"] = "accessIssue";
    NoteCategory["ERROR"] = "error";
    NoteCategory["FULFILLMENT_ISSUE"] = "fulfillmentIssue";
    NoteCategory["MEDICAL_ORDER"] = "medicalOrder";
    NoteCategory["SAMPLE_LABELS_OK"] = "sampleLabelsOk";
    NoteCategory["SAMPLE_LABEL_MISSPELLED"] = "sampleLabelMisspelled";
    NoteCategory["SAMPLE_NOT_LABELED"] = "sampleNotLabeled";
    NoteCategory["SCHEDULING"] = "scheduling";
    NoteCategory["SUPPLY_ISSUE"] = "supplyIssue";
    NoteCategory["TECH_ISSUE"] = "techIssue";
})(NoteCategory || (NoteCategory = {}));
/**
 * The overall object on which the input (eg. Feedback, Note) is based
 * This is shared with Feedback, Feedback currently only supports Itinerary
 */
export var OriginType;
(function (OriginType) {
    OriginType["ITINERARY"] = "itinerary";
    OriginType["ORDER"] = "order";
})(OriginType || (OriginType = {}));
//# sourceMappingURL=note.js.map